import { ExtraBenefitMasterService } from "../../src/services/ExtraBenefitMasterService";
import { ExtraBenefitMasterConstants } from "../constants/ExtraBenefitMasterConstants";
import { alertActions } from ".";

export const ExtraBenefitMasterActions = {
  getAll,
  getSubAll,
  createCatagory,
  createContractor,
  updateCategory,
  updateContractor,
  openDialog,
  inActiveRow,
  inActiveRow2,
  onHideShow,
  onHideShow2,
  loadingData,
  loadingData2,
  onHideShowIsActive,
  onHideShowIsActive2,
  getCategoryDDL,
  createSubCategory,
  SubUpdateCategory,
  getSubCategoryDDL,
};



function getAll(data) {
  return (dispatch) => {
    // Add safety + visibility
    console.log("📤 [getAll] Received payload:", data);

    if (!data || !data.First || !data.PageSize) {
      console.error("⚠️ [getAll] Invalid payload for GetExtraBenefit:", data);
      dispatch(failure("Invalid payload passed to getAll"));
      return;
    }

    dispatch(request());
    dispatch(loadingData(true));

    ExtraBenefitMasterService.getCategory(data)
      .then((response) => {
        console.log("✅ [getAll] API response:", response);
        dispatch(loadingData(false));
        dispatch(success(response.ResponseData));
      })
      .catch((error) => {
        console.error("❌ [getAll] API error:", error);
        dispatch(loadingData(false));
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      });
  };

  function request() {
    return { type: ExtraBenefitMasterConstants.GETALL_REQUEST };
  }
  function success(datas) {
    return { type: ExtraBenefitMasterConstants.GETALL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: ExtraBenefitMasterConstants.GETALL_FAILURE, error };
  }
}

function getSubAll(data) {
  return (dispatch) => {
    dispatch(request());
    ExtraBenefitMasterService.getSubCategory(data).then(
      (response) => {
        dispatch(loadingData2(false));
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(loadingData2(false));
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: ExtraBenefitMasterConstants.GETSUBALL_REQUEST };
  }
  function success(datas) {
    return { type: ExtraBenefitMasterConstants.GETSUBALL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: ExtraBenefitMasterConstants.GETSUBALL_FAILURE, error };
  }
}

function createCatagory(data, obj) {

  return (dispatch) => {
    dispatch(request(data));
    ExtraBenefitMasterService.createCategory(data).then(
      (response) => {
        //history.push('/');
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {

            dispatch(success(response.ResponseData));
            dispatch(onHideShow(false));
            dispatch(getAll(obj));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: ExtraBenefitMasterConstants.CREATE_REQUEST, data };
  }
  function success(data) {
    return { type: ExtraBenefitMasterConstants.CREATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: ExtraBenefitMasterConstants.CREATE_FAILURE, error };
  }
}

function createContractor(data, obj) {

  return (dispatch) => {
    dispatch(request(data));
    ExtraBenefitMasterService.createContractor(data).then(
      (response) => {
        //history.push('/');
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {

            dispatch(success(response.ResponseData));
            dispatch(onHideShow(false));
            dispatch(getAll(obj));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: ExtraBenefitMasterConstants.CREATE_REQUESTC, data };
  }
  function success(data) {
    return { type: ExtraBenefitMasterConstants.CREATE_SUCCESSC, data };
  }
  function failure(error) {
    return { type: ExtraBenefitMasterConstants.CREATE_FAILUREC, error };
  }
}

function createSubCategory(data) {
  return (dispatch) => {
    dispatch(request(data));
    ExtraBenefitMasterService.createSubCategory(data).then(
      (response) => {
        //history.push('/');
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            ;
            dispatch(success(response.ResponseData));
            dispatch(onHideShow(false));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: ExtraBenefitMasterConstants.CREATE_REQUEST, data };
  }
  function success(data) {
    return { type: ExtraBenefitMasterConstants.CREATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: ExtraBenefitMasterConstants.CREATE_FAILURE, error };
  }
}


function updateCategory(data) {
  return (dispatch) => {
    dispatch(request(data));
    ExtraBenefitMasterService.updateCategory(data).then(
      (response) => {
        //history.push('/');
        if (response && response.ResponseCode) {
          ;
          if (response.ResponseCode === "200") {
            dispatch(success(data));
            dispatch(onHideShow(false));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: ExtraBenefitMasterConstants.UPDATE_REQUEST, data };
  }
  function success(data) {
    return { type: ExtraBenefitMasterConstants.UPDATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: ExtraBenefitMasterConstants.UPDATE_FAILURE, error };
  }
}

// function updateContractor(data) {
//   return (dispatch) => {
//     dispatch(request(data));
//     ExtraBenefitMasterService.updateContractor(data).then(
//       (response) => {
//         //history.push('/');
//         if (response && response.ResponseCode) {
//           ;
//           if (response.ResponseCode === "200") {
//             dispatch(success(data));
//             dispatch(onHideShow(false));
//             dispatch(alertActions.success(response.ResponseMessage));
//           } else if (response.ResponseCode === "400") {
//             dispatch(alertActions.warning(response.ResponseMessage));
//           } else {
//             dispatch(alertActions.error(response.ResponseMessage));
//           }
//         }
//       },
//       (error) => {
//         dispatch(failure(error.toString()));
//         dispatch(alertActions.error(error.toString()));
//       }
//     );
//   };

//   function request(data) {
//     return { type: ExtraBenefitMasterConstants.UPDATE_REQUEST, data };
//   }
//   function success(data) {
//     return { type: ExtraBenefitMasterConstants.UPDATE_SUCCESS, data };
//   }
//   function failure(error) {
//     return { type: ExtraBenefitMasterConstants.UPDATE_FAILURE, error };
//   }
// }

function updateContractor(data) {
  return (dispatch) => {
    dispatch(request(data));

    return ExtraBenefitMasterService.updateContractor(data).then( // ✅ Return this promise
      (response) => {
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            dispatch(success(data));
            dispatch(onHideShow(false));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
        return response; // ✅ Optional: return response to component
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
        throw error; // ✅ Rethrow to catch in component
      }
    );
  };

  function request(data) {
    return { type: ExtraBenefitMasterConstants.UPDATE_REQUEST, data };
  }
  function success(data) {
    return { type: ExtraBenefitMasterConstants.UPDATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: ExtraBenefitMasterConstants.UPDATE_FAILURE, error };
  }
}


function SubUpdateCategory(data) {
  return (dispatch) => {
    dispatch(request(data));
    ExtraBenefitMasterService.SubUpdateCategory(data).then(
      (response) => {
        //history.push('/');
        if (response && response.ResponseCode) {
          ;
          if (response.ResponseCode === "200") {
            dispatch(success(data));
            dispatch(onHideShow(false));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: ExtraBenefitMasterConstants.UPDATE_REQUEST, data };
  }
  function success(data) {
    return { type: ExtraBenefitMasterConstants.UPDATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: ExtraBenefitMasterConstants.UPDATE_FAILURE, error };
  }
}


function inActiveRow(batchid, isActive, obj) {
  const data = {
    BatchId: batchid,
    IsActive: isActive,
  };

  return (dispatch) => {
    dispatch(request());

    return ExtraBenefitMasterService.inActiveRow(batchid, isActive, obj) // <-- RETURN this Promise
      .then((response) => {
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            dispatch(success(data));
            dispatch(onHideShowIsActive(false));
            dispatch(alertActions.success(response.ResponseMessage));
            dispatch(getAll(obj)); // this should fetch fresh data
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }

        return response; // resolve with response
      })
      .catch((error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
        throw error; // ensure rejection if error
      });
  };

  function request() {
    return { type: ExtraBenefitMasterConstants.ISACTIVE_REQUEST };
  }
  function success(data) {
    return { type: ExtraBenefitMasterConstants.ISACTIVE_SUCCESS, data };
  }
  function failure(error) {
    return { type: ExtraBenefitMasterConstants.ISACTIVE_FAILURE, error };
  }
}


function inActiveRow2(category, isActive) {
  var data = {
    SubCatId: category,
    IsActive: isActive,
  };
  return (dispatch) => {
    dispatch(request());

    ExtraBenefitMasterService.inActiveRow2(category, isActive).then(
      (response) => {
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            dispatch(success(data));
            dispatch(onHideShowIsActive(false));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: ExtraBenefitMasterConstants.ISACTIVE2_REQUEST };
  }
  function success(data) {
    return { type: ExtraBenefitMasterConstants.ISACTIVE2_SUCCESS, data };
  }
  function failure(error) {
    return { type: ExtraBenefitMasterConstants.ISACTIVE2_FAILURE, error };
  }
}

function onHideShow(isbool) {
  return {
    type: ExtraBenefitMasterConstants.DIALOG_REQUEST,
    isbool,
  };
}


function onHideShow2(isbool) {
  return {
    type: ExtraBenefitMasterConstants.DIALOG_REQUEST2,
    isbool,
  };
}

function loadingData(isbool) {
  return {
    type: ExtraBenefitMasterConstants.LOADING_REQUEST,
    isbool,
  };
}
function loadingData2(isbool) {
  return {
    type: ExtraBenefitMasterConstants.LOADING_REQUEST2,
    isbool,
  };
}
function onHideShowIsActive(isbool) {
  return {
    type: ExtraBenefitMasterConstants.DIALOG_ISACTIVE_REQUEST,
    isbool,
  };
}
function onHideShowIsActive2(isbool) {
  return {
    type: ExtraBenefitMasterConstants.DIALOG_ISACTIVE_REQUEST2,
    isbool,
  };
}

function openDialog(data) {
  return {
    type: ExtraBenefitMasterConstants.OPEN_DIALOG_REQUEST,
    data,
  };
}

function getCategoryDDL(data, flag) {
  return (dispatch) => {
    dispatch(request());
    ExtraBenefitMasterService.fetchCategoryDLL(data).then(
      (response) => {


        // if (flag == 1) {
        //   response.ResponseData.splice(0, 0, { label: "All", value: "0" });
        // }
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: ExtraBenefitMasterConstants.GETCATEGORYDDL_REQUEST };
  }
  function success(datas) {
    return { type: ExtraBenefitMasterConstants.GETCATEGORYDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: ExtraBenefitMasterConstants.GETCATEGOYRDDL_FAILURE, error };
  }
}


function getSubCategoryDDL(data) {
  return (dispatch) => {
    dispatch(request());
    ExtraBenefitMasterService.fetchSubCategoryDLL(data).then(
      (response) => {

        // if (flag == 1) {
        //   response.ResponseData.splice(0, 0, { label: "All", value: "0" });
        // }
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: ExtraBenefitMasterConstants.GETSUBCATEGORYDDL_REQUEST };
  }
  function success(datas) {
    return { type: ExtraBenefitMasterConstants.GETSUBCATEGORYDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: ExtraBenefitMasterConstants.GETSUBCATEGORYDDL_FAILURE, error };
  }
}